/**
 * ApiHoundWorkspace - HTTP Request Testing Environment
 *
 * A workspace for API testing and debugging.
 *
 * Features:
 * - HTTP method selection (GET, POST, PUT, PATCH, DELETE)
 * - URL endpoint input with API registry integration
 * - Headers management with presets
 * - JSON body editor with validation
 * - Response display with formatting
 * - Multi-tab support for comparing requests
 */

import React from 'react';
import { Box } from '@mui/material';
import LlmPlayground from '../../LlmPlayground';
import { useTheme as useAppTheme } from '../../../contexts/ThemeContext';

/**
 * ApiHoundWorkspace Component
 *
 * @param {Object} colors - Theme colors object (optional, will use context if not provided)
 */
const ApiHoundWorkspace = ({ colors: propColors }) => {
  const { colors: contextColors } = useAppTheme();
  const colors = propColors || contextColors;

  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        bgcolor: colors.background,
        overflow: 'hidden',
      }}
    >
      <LlmPlayground
        standalone={true}
        embedded={true}
        initialTabType="api"
      />
    </Box>
  );
};

export default ApiHoundWorkspace;
